import { Box, Stack, Tooltip, Typography } from '@dtx-company/design-system/src'
import { FC, ReactElement, ReactNode } from 'react'
import { Help } from '@mui/icons-material'

interface TitleProps {
  title: string
  icon?: ReactNode
  tooltip?: string
}

export const FormTitle: FC<TitleProps> = ({ title, icon, tooltip }: TitleProps) => {
  return (
    <Stack direction="row" alignItems="center" gap={2}>
      {icon}
      <Typography variant="h3">{title}</Typography>
      {tooltip && tooltip.length > 0 && (
        <Tooltip title={tooltip}>
          <Help />
        </Tooltip>
      )}
    </Stack>
  )
}

export const PreviewTitle = (): ReactElement => (
  <Box sx={{ marginBottom: 1 }}>
    <Typography color="primary.black" variant="h4">
      Preview
    </Typography>
  </Box>
)
